import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div style={styles.container}>
            {/* Logo */}
            <img src="/proactr_logo_dark.png" alt="ProACTr Logo" style={styles.logo} />

            {/* Funny 404 Message */}
            <h1 style={styles.heading}>Oops! 404 - Page Not Found</h1>
            <p style={styles.message}>
                It looks like you may have reached this page in error...
                <br />
                or maybe you're on a quest for hidden content?
            </p>
            <p style={styles.joke}>
                <em>Either way, our AI is judging you silently.</em> <span style={{ fontSize: '22px' }}>🤖</span>
                <br />
                (But don’t worry, we still think you're a great leader!)
            </p>

            {/* Back to Home Link */}
            <Link to="/dashboard" style={styles.link}>Go to Home</Link>
        </div>
    );
};

// 🎨 Styles
const styles = {
    container: {
        textAlign: 'center',
        padding: '50px',
        backgroundColor: '#282c34', // Dark background to match ProACTr theme
        color: '#ffffff',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start', // Move content higher up
        paddingTop: '15vh', // Add spacing from the top
        marginTop: '-70px',
    },
    logo: {
        width: '500px',
        marginBottom: '20px',
    },
    heading: {
        fontSize: '36px',
        fontWeight: 'bold',
    },
    message: {
        fontSize: '20px',
        marginTop: '10px',
    },
    joke: {
        fontSize: '18px',
        marginTop: '15px',
        opacity: 0.9,
    },
    link: {
        marginTop: '20px',
        fontSize: '18px',
        color: '#ffcc00',
        textDecoration: 'none',
        padding: '10px 20px',
        border: '2px solid #ffcc00',
        borderRadius: '5px',
        transition: 'background 0.3s ease-in-out',
    },
};

export default NotFound;